export default __webpack_public_path__ + "static/media/baby_cap.ff17066f.jpg";